/**
 * PostHog connection config — single source of truth for host + token.
 *
 * The host is hardcoded to PostHog **EU Cloud** by default, so you only need to
 * set the project token. Override the region with `NEXT_PUBLIC_POSTHOG_HOST`
 * (e.g. `https://us.i.posthog.com` or a self-hosted URL) if you ever move it.
 *
 * `NEXT_PUBLIC_*` are inlined at build time, so these resolve to string literals
 * in the browser bundle. Dependency-free — safe to import anywhere (no posthog-js).
 */
const DEFAULT_POSTHOG_HOST = "https://eu.i.posthog.com";

/** Ingestion/API host. Always resolves (falls back to EU); override via env. */
export const POSTHOG_HOST =
  process.env.NEXT_PUBLIC_POSTHOG_HOST || DEFAULT_POSTHOG_HOST;

/** Per-project public token. Empty when unset — this is the real on/off switch. */
export const POSTHOG_PROJECT_TOKEN =
  process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN || "";

/** PostHog is active once a project token exists; the host always resolves. */
export function isPostHogConfigured(): boolean {
  return Boolean(POSTHOG_PROJECT_TOKEN);
}
